module.exports = __webpack_public_path__ + "~@/assets/img/whatExif-2.7333c51b.png";